
































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import SwWidgetHeaderSettings from './sw-widget-header-settings.vue';

const cssPrefix = 'sw-widget-header';

@Component({
  components: {
    SwIcon,
    SwWidgetHeaderSettings,
  },
  directives: {
    tooltip,
  },
})
export default class SwWidgetHeader extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: String, required: false, default: 'Panel Title' })
  title: string;

  @Prop({ type: String, required: false, default: '' })
  timeframe: string;

  @Prop({ required: true })
  index: number;

  @Prop({ required: false })
  groupByOptions: string[];

  @Prop({ type: Boolean })
  isLoading: boolean;

  @Prop({ type: String, required: false, default: '' })
  groupBy: string;

  @Prop({ type: Boolean, required: false, default: false })
  disableRemove: boolean;

  @Prop({ type: String, required: false, default: '' })
  tenantGroup: string;

  @Prop({ type: Boolean, required: false, default: false })
  disableEdit: boolean;
}
